// extracted by mini-css-extract-plugin
export default {"mCard":"tC-z","image":"uC-z","imageNoBackground":"vC-z","imageHasCategory":"wC-z","fullWidth":"xC-z"};